import theme from 'src/theme';
import { durations } from '../background/styles';

export const duration = durations.images;
export const delay = durations.width;
export const durationEnd = delay + duration;

export default {
  bottom: {
    display: 'flex',
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
  },

  appear: {
    ...(theme.mixins.animation.transitionDuration(duration, 'opacity')),
    transitionDelay: `${delay}ms`,

    opacity: 0,
  },

  appearActive: {
    opacity: 1,
  },
};
